import _ from 'lodash'

export default {
  setActive: (state, which) => {
    state.active = _.isBoolean(which) ? which : false
  },
  setComplete: (state, which) => {
    state.complete = _.isBoolean(which) ? which : false
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/splash/mutations.js